import type { CSSProperties } from "react";

import type { ColorTheme } from "./theme";

const clerkCard: CSSProperties = {
  boxShadow: "none",
  border: "0",
  background: "transparent",
};

const clerkInput: CSSProperties = {
  borderRadius: "8px",
  border: "1px solid var(--rule-dark)",
  background: "var(--paper)",
  boxShadow: "none",
  minHeight: "40px",
  padding: "9px 11px",
};

const clerkElements = {
  rootBox: { width: "100%" },
  cardBox: clerkCard,
  card: clerkCard,
  headerTitle: { display: "none" },
  headerSubtitle: { display: "none" },
  formFieldLabel: {
    color: "var(--ink-soft)",
    fontSize: "0.875rem",
    fontWeight: "500",
  },
  formFieldInput: clerkInput,
  socialButtonsBlockButton: {
    border: "1px solid var(--rule-dark)",
    boxShadow: "none",
    borderRadius: "8px",
    minHeight: "40px",
    background: "var(--paper-strong)",
    color: "var(--ink)",
  },
  socialButtonsBlockButtonText: {
    fontWeight: "600",
    color: "var(--ink)",
  },
  formButtonPrimary: {
    background: "var(--accent-fill)",
    color: "var(--accent-on)",
    border: "1px solid var(--accent-fill)",
    boxShadow: "none",
    fontWeight: "600",
    borderRadius: "8px",
    minHeight: "40px",
  },
  footer: {
    background: "transparent",
    boxShadow: "none",
    borderTop: "1px solid var(--rule)",
  },
  footerAction: { display: "none" },
};

export function clerkAuthAppearanceFor(
  theme: ColorTheme,
  options: { readonly hideClerkHeader?: boolean } = {},
) {
  const dark = theme === "dark";
  return {
    variables: {
      colorPrimary: dark ? "#d8dee8" : "#303844",
      colorTextOnPrimaryBackground: dark ? "#20242c" : "#ffffff",
      colorText: dark ? "#edf0f4" : "#252a32",
      colorTextSecondary: dark ? "#a4adba" : "#616a77",
      colorBackground: dark ? "#22262e" : "#ffffff",
      colorInputBackground: dark ? "#292e38" : "#ffffff",
      colorInputText: dark ? "#edf0f4" : "#252a32",
      colorDanger: dark ? "#f3949a" : "#b5383d",
      colorNeutral: dark ? "#a4adba" : "#616a77",
      borderRadius: "8px",
      fontFamily: '"IBM Plex Sans Variable", sans-serif',
    },
    elements: {
      ...clerkElements,
      ...(options.hideClerkHeader === true
        ? { header: { display: "none" } }
        : {}),
    },
  };
}
